import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.orderFiltersSettings.title',
    defaultMessage: 'Order product filter mapping',
    description: 'title of the order filters settings on the configuration page',
  },
  display: {
    title: {
      id: 'pages.settings.general.orderFiltersSettings.display.brandFilters',
      defaultMessage: 'Brand filters',
      description:
        'title of the brand filters rule of the  order filters settings on the configuration page',
    },
  },
  feedback: {
    orderFiltersSettingsUpdated: {
      id: 'pages.settings.general.orderFiltersSettings.feedback.orderFiltersSettingsUpdated',
      defaultMessage: 'Order filter settings saved',
      description: 'feedback on the successful update of price group settings',
    },
    orderFiltersSettingsNotUpdated: {
      id: 'pages.settings.general.orderFiltersSettings.feedback.orderFiltersSettingsNotUpdated',
      defaultMessage: 'Order filter settings could not be saved',
      description: 'feedback on the failed update of price group settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.orderFiltersSettings.editDrawer.title',
      defaultMessage: 'Edit brand filters',
      description: 'title of the edit price group drawer',
    },
    filtersField: {
      label: {
        id: 'properties.filters',
        defaultMessage: 'Filters',
        description: 'label of the filters field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
